@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;
@use "../../styles/colors.module.scss" as color;

.richText {
    > :first-child {
        margin-top: 0;
    }

    > :last-child {
        margin-bottom: 0;
    }

    img {
        display: inline;
    }

    hr {
        color: var(--mid-gray);
        border-top: 0;
    }
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-16);
}

.listItem {
    composes: fontP20 from "../../styles/typography.module.scss";
    position: relative;
    margin-block: var(--spacer-12);
}

.list {
    composes: listReset from "../../styles/utils.module.scss";
    margin-block: var(--spacer-24);
    padding-left: calc(24px + var(--spacer-8));
}

.ulist {
    composes: list;

    li::before {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        background-color: var(--red);
        border-radius: var(--border-radius-full);

        // spacer 8 + 8px padding + 8px width from left edge
        left: calc(-1 * (var(--spacer-8) + 16px));
        // middle (0.5lh) - half the height of the circle (4px)
        top: calc(0.5lh - 4px);
    }
}

.olist {
    composes: list;

    li {
        counter-increment: level1;

        &::before {
            content: counter(level1) ". ";
            font: var(--font-hb-24);
            color: var(--red);
            white-space: pre; // don't trim trailing whitespace
            position: absolute;

            // spacer 8 + 20px (to left edge of box in figma) - spacer 4 (padding)
            left: calc(-1 * (var(--spacer-8) + 20px - var(--spacer-4)));
            top: var(--spacer-4);
        }
    }
}

:where(.h1) {
    margin-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-hb-104);
}

:where(.h2) {
    margin-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-hb-80);
}

:where(.h3) {
    margin-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-hb-48);
}

:where(.h4) {
    margin-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-sh-40);
    letter-spacing: -0.01em;
}

:where(.h5) {
    margin-block: var(--spacer-32) var(--spacer-24);
    font: var(--font-hb-48);
}

:where(.h6) {
    margin-block: var(--spacer-24) var(--spacer-16);
    font: var(--font-hb-40);
}

:where(.h1, .h2, .h3, .h4, .h5, .h6) {
    b {
        font-weight: inherit;
    }
}

.buttonPrimaryText {
    font: var(--font-button-20);
    color: var(--accent);
}

.eyebrow {
    font: var(--font-st-20);
    font-weight: 800;
}

.dropCap > :first-child::first-letter {
    font:
        500 5.5em / 0.9 "PP Right Grotesk",
        sans-serif;
    float: left;
    margin-right: var(--spacer-12);
    margin-bottom: -0.04lh;
}

.richTextBlock {
    composes: richText;
    grid-column: col-start 4 / span 6;

    @media ($below-tablet) {
        grid-column: col-start 2 / span 10;
    }

    @media ($below-mobile) {
        grid-column: content;
    }

    :where(&) {
        grid-column: inherit;
    }
}

:where(.footnote) {
    font: var(--font-p-16);
}

.super {
    font-size: 14px;
}

.footnoteRef {
    font-size: 0.75em;
    line-height: 0;
    vertical-align: super;

    a {
        color: inherit;
        text-decoration: none;

        &:hover,
        &:focus-visible {
            text-decoration: underline;
        }
    }
}

.footnoteBacklink {
    margin-inline-start: 0.25em;
    color: inherit;
    text-decoration: none;

    &:hover,
    &:focus-visible {
        text-decoration: underline;
    }
}
